(() => {
  const initTestimonialsCarousels = () => {
    const carousels = document.querySelectorAll('[data-gr-home-testimonials]');
    if (!carousels || carousels.length === 0) return;

    carousels.forEach((carousel) => {
      const grid = carousel.querySelector('[data-gr-home-testimonials-grid]');
      const cards = carousel.querySelectorAll('.gr-home-testimonials__card');
      const gridScroller = carousel.querySelector('.gr-home-testimonials__grid-scroller');
      const prevButton = carousel.querySelector('[data-gr-home-testimonials-prev]');
      const nextButton = carousel.querySelector('[data-gr-home-testimonials-next]');
      if (!grid || !cards || cards.length <= 1 || !gridScroller) return;

      const intervalMsAttr = carousel.getAttribute('data-gr-home-testimonials-interval');
      const intervalMs = intervalMsAttr ? parseInt(intervalMsAttr, 10) : 4500;
      if (!Number.isFinite(intervalMs) || intervalMs < 1000) return;

      let activeIndex = 0;
      let timer = null;
      let isPaused = false;

      const prefersReducedMotion = window.matchMedia
        ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
        : false;

      const pause = () => {
        isPaused = true;
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      const goToIndex = (index) => {
        activeIndex = index;
        const card = cards[activeIndex];
        if (!card) return;

        // Evita o comportamento do scrollIntoView que pode mover a página inteira.
        // Como o carrossel é horizontal, ajustamos apenas o scroller.
        const left = card.offsetLeft;
        gridScroller.scrollTo({
          left,
          behavior: prefersReducedMotion ? 'auto' : 'smooth'
        });
      };

      const play = () => {
        if (prefersReducedMotion) return;
        if (isPaused === false && timer) return;
        isPaused = false;

        timer = window.setInterval(() => {
          if (isPaused) return;
          const nextIndex = (activeIndex + 1) % cards.length;
          goToIndex(nextIndex);
        }, intervalMs);
      };

      const onInteractionStart = () => pause();
      const onInteractionEnd = () => play();

      carousel.addEventListener('mouseenter', onInteractionStart, { passive: true });
      carousel.addEventListener('mouseleave', onInteractionEnd, { passive: true });
      carousel.addEventListener('focusin', onInteractionStart);
      carousel.addEventListener('touchstart', onInteractionStart, { passive: true });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) pause();
        else play();
      });

      if (prevButton) {
        prevButton.addEventListener('click', (e) => {
          e.preventDefault();
          pause();
          const prevIndex = (activeIndex - 1 + cards.length) % cards.length;
          goToIndex(prevIndex);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', (e) => {
          e.preventDefault();
          pause();
          const nextIndex = (activeIndex + 1) % cards.length;
          goToIndex(nextIndex);
        });
      }

      // Garante que a primeira renderização já comece no primeiro depoimento.
      goToIndex(0);

      if (!prefersReducedMotion) play();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonialsCarousels, { once: true });
  } else {
    initTestimonialsCarousels();
  }
})();

